import Dialog from "ui/elements/dialog/Dialog";
import {i18n} from "ui/i18n";
import Form from "ui/elements/form/Form";

/**
 * @typedef {object} T_SwirlSetupResult
 * @property {number} twistsFrom
 * @property {number} twistsTo
 */

export default class SwirlSetup extends Dialog {
	/**
	 * @param {boolean} [rangeMode]
	 */
	constructor(rangeMode = false) {
		super({
			title: i18n('title.swirl-setup'),
			smallWidth: true,
			buttons: [
				{
					caption: i18n('buttons.apply'),
					role: 'apply',
					icon: '/images/icons.svg#icon-svg-check'
				},
				{
					caption: i18n('buttons.close'),
					role: 'close'
				}
			]
		});

		this._rangeMode = rangeMode;

		/**
		 * @type {Form}
		 * @private
		 */
		this._form = null;

		/**
		 * @type {?function(res:T_SwirlSetupResult|null)}
		 * @private
		 */
		this._onComplete = null;

		void this._buildForm();
	}

	/**
	 * @returns {Promise<T_SwirlSetupResult|null>}
	 */
	getResultPromise() {
		return new Promise((resolve) => {
			this._onComplete = resolve;
		});
	}

	/**
	 * @override
	 * @param {string} role
	 * @returns {void}
	 * @protected
	 */
	_handleButton(role) {
		super._handleButton(role);
		if (role === 'apply') {
			let data = this._form.getValues();
			if (data !== null) {
				this._apply(data);
			}
		}
	}

	/**
	 * @private
	 * @param {Object} data
	 * @returns {void}
	 */
	_apply(data) {
		if (this._onComplete) {
			this._onComplete({
				twistsFrom: parseInt(data.twistsFrom),
				twistsTo: parseInt(this._rangeMode ? data.twistsTo : data.twistsFrom)
			});
			this._onComplete = null;
			this.destroy();
		}
	}

	/**
	 * @private
	 * @returns {Promise<void>}
	 */
	async _buildForm() {
		let el = document.createElement('div');
		this._form = new Form({
			parent: el,
			onApply: this._apply.bind(this),
			values: {twistsFrom: 1, twistsTo: 1},
			fields: [
				{
					type: 'uint',
					name: 'twistsFrom',
					min: 0,
					max: 20,
					step: 1,
					caption: i18n(this._rangeMode ? 'inputs.layer.twists-from' : 'inputs.layer.twists'),
				},
				{
					type: this._rangeMode ? 'uint' : 'hidden',
					name: 'twistsTo',
					min: 0,
					max: 20,
					step: 1,
					caption: i18n('inputs.layer.twists-to'),
				},
			]
		});
		this.setContent(el);
	}

	/**
	 * @returns {void}
	 */
	destroy() {
		if (this._onComplete !== null) {
			this._onComplete(null);
			this._onComplete = null;
		}
		super.destroy();
	}
}
